var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useField } from 'react-final-form';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText/FieldErrorText';
import { FileField } from '@/components/functional/Form/FileField';
import { FIELD_KEY_NAME_FILE } from '@/components/modules/form/FileUploadField/const';
import { useFileUploadField } from '@/components/modules/form/FileUploadField/useFileUploadField';
import { UploadFileButton } from '@/components/ui/Form/UploadFile/UploadFileButton';
import { UploadFileLink } from '@/components/ui/Form/UploadFile/UploadFileLink';
/**
 * ファイル選択（onChange 時にアップロード + ファイル表示有）
 * @param props
 * @returns
 */
export const SingleFileUploadField = (props) => {
    const { className = '', fieldKeyNameOfId, fieldKeyNameOfName, fieldKeyNameOfNewId, fieldKeyNameOfPath, name, onClickLink, uploadFile, validateOfFile, validateOfNewId } = props, fileFieldProps = __rest(props, ["className", "fieldKeyNameOfId", "fieldKeyNameOfName", "fieldKeyNameOfNewId", "fieldKeyNameOfPath", "name", "onClickLink", "uploadFile", "validateOfFile", "validateOfNewId"]);
    const fieldNameOfFile = `${name}.${FIELD_KEY_NAME_FILE}`;
    const fieldNameOfId = `${name}.${fieldKeyNameOfId}`;
    const fieldNameOfNewId = `${name}.${fieldKeyNameOfNewId}`;
    // Field id
    const { input: { value: idValue }, } = useField(fieldNameOfId);
    // Field file
    const { input: { onChange: onChangeFile, value: fileValue }, meta: { invalid }, } = useField(fieldNameOfFile, {
        subscription: { invalid: true, value: true },
        validate: validateOfFile,
    });
    // ファイルアップロード処理
    const { inputFile, loading, nameValue, newIdValue, pathValue } = useFileUploadField({
        fieldKeyNameOfName,
        fieldKeyNameOfNewId,
        fieldKeyNameOfPath,
        fieldName: name,
        fileValue,
        invalid,
        onChangeFile,
        uploadFile,
        validateOfNewId,
    });
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-col gap-16', className) }, { children: [!!((inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) || nameValue) && (_jsxs("div", { children: [pathValue ? (
                    // ファイルのパスが存在する場合、ファイル名は通常リンクとして表示
                    _jsx(UploadFileLink, { fileLink: pathValue, fileName: (inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) || nameValue, hasUploadError: !!(inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) && invalid, isUploading: loading })) : (
                    // ファイルのパスが存在しない（＝IDしかない）場合、ファイル名はボタンにする（API経由でファイルダウンロードさせる挙動を想定）
                    _jsx(UploadFileButton, { fileName: (inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) || nameValue, hasUploadError: !!(inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) && invalid, id: newIdValue || idValue, isUploading: loading, onClickLink: onClickLink })), _jsx(FieldErrorText, { name: fieldNameOfFile })] })), !invalid && _jsx(FieldErrorText, { name: fieldNameOfNewId }), _jsx(FileField, Object.assign({}, fileFieldProps, { isHideValidateError: true, name: fieldNameOfFile, validate: validateOfFile }))] })));
};
